import { defineMessages } from 'react-intl';

const messages = defineMessages({
  activityTrackerDescription: {
    id: '4aKykC',
    defaultMessage: 'Dashboard to monitor and analyze events in IBM Cloud',
  },
  secretsManagerName: {
    id: 'xyfSnR',
    defaultMessage: 'IBM Cloud Secrets Manager',
  },
  bareMetalName: {
    id: 'w2FJX4',
    defaultMessage: 'IBM Cloud Bare Metal Servers',
  },
  appLearnMore: {
    id: 'q9Malo',
    defaultMessage: 'AI on IBM Cloud',
  },
  cloudpakbaDescription: {
    id: 'Bjs0bd',
    defaultMessage: 'Operations management software with AI insights',
  },
  db2Name: {
    id: 'QiEOvL',
    defaultMessage: 'IBM Db2® on Cloud',
  },
  networkAppliancesDescription: {
    id: 'MojMtC',
    defaultMessage: 'Physical and virtual routers, firewalls, VPNs and more',
  },
  watsonLanguageUnderstandingName: {
    id: 'ZZG8Oi',
    defaultMessage: 'IBM Watson Natural Language Understanding',
  },
  eventStreamsDescription: {
    id: '7xSb+w',
    defaultMessage: 'PaaS stream processing based on Apache Kafka',
  },
  cloudCliDescription: {
    id: '8C8NDW',
    defaultMessage: 'A CLI to manage your IBM Cloud',
  },
  kubernetesName: {
    id: '0UBJ54',
    defaultMessage: 'IBM Cloud Kubernetes Service',
  },
  cloudFunctionsDescription: {
    id: 'Cke3Eg',
    defaultMessage: 'Serverless function runtime based on Apache OpenWhisk',
  },
  cloudpaknaDescription: {
    id: 'RfQ1sv',
    defaultMessage: 'Management software for telco network operations',
  },
  istioName: {
    id: '6R0f5Z',
    defaultMessage: 'Istio on IBM Cloud',
  },
  hyperProtectDbaasName: {
    id: 'RsuUiH',
    defaultMessage: 'IBM Hyper Protect DBaaS',
  },
  liftDescription: {
    id: '1scQvB',
    defaultMessage: 'Toolkit to migrate on-premises data to the cloud',
  },
  cloudMqDescription: {
    id: 'p33z2x',
    defaultMessage: 'Managed message broker',
  },
  asperaName: {
    id: 'viCUfU',
    defaultMessage: 'IBM Aspera® on Cloud',
  },
  hyperProtectVirtualServersName: {
    id: 'vfoXSK',
    defaultMessage: 'IBM Hyper Protect Virtual Servers',
  },
  sslCertificatesName: {
    id: 'YhthEh',
    defaultMessage: 'SSL certificates',
  },
  liftName: {
    id: 'HiuEPq',
    defaultMessage: 'IBM Lift',
  },
  securityModuleDescription: {
    id: 'hmsbqG',
    defaultMessage:
      'Tamper-resistant hardware to store and process cryptographic keys',
  },
  analyticsEngineName: {
    id: '3HMsx5',
    defaultMessage: 'IBM Analytics Engine',
  },
  infosphereDescription: {
    id: '0uWolc',
    defaultMessage: 'Data integration suite for ETL, governance and anlaysis',
  },
  pakDataDescription: {
    id: 'YQrc3L',
    defaultMessage: 'Tools for data analysis, organization and management',
  },
  continuousDeliveryName: {
    id: 'd0J9+U',
    defaultMessage: 'IBM Cloud Continuous Delivery',
  },
  informixName: {
    id: 'xklCtM',
    defaultMessage: 'IBM Informix® on Cloud',
  },
  cloudMqName: {
    id: 'fn+qTy',
    defaultMessage: 'IBM MQ on Cloud',
  },
  hyperProtectCryptoServicesDescription: {
    id: '0BsYsn',
    defaultMessage: 'Cloud hardware to store and process cryptographic keys',
  },
  qiskitName: {
    id: 'IKkrDs',
    defaultMessage: 'Qiskit',
  },
  iotPlatformName: {
    id: '9p/LP6',
    defaultMessage: 'IBM Maximo Application Suite: Remote monitoring',
  },
  qiskitRuntimeName: {
    id: 'Cj9muP',
    defaultMessage: 'Qiskit Runtime',
  },
  watsonLanguageClassifierDescription: {
    id: 'nN08p2',
    defaultMessage: 'Visual tool and API for text classification',
  },
  powerVirtualServerDescription: {
    id: 'OvH4dR',
    defaultMessage: 'Virtual servers with IBM POWER processors',
  },
  loudNetworkSecurityName: {
    id: 'ksyFu4',
    defaultMessage: 'IBM Cloud network security',
  },
  pakSecurityName: {
    id: 'v+D0LH',
    defaultMessage: 'IBM Cloud Pak for Security',
  },
  'logAnalysisName:': {
    id: '/ViV2M',
    defaultMessage: 'IBM Cloud Log Analysis',
  },
  cloudCliName: {
    id: '4TUmUg',
    defaultMessage: 'IBM Cloud CLI',
  },
  watsonLanguageUnderstandingDescription: {
    id: 'x/h7yL',
    defaultMessage: 'API for text analysis and metadata extraction',
  },
  securityAdvisorName: {
    id: 'glP6MT',
    defaultMessage: 'IBM Cloud Security Advisor',
  },
  integrationDescription: {
    id: '8ytOBq',
    defaultMessage:
      'Integrate your apps through APIs, messaging and networking tools',
  },
  codeEngineName: {
    id: 'cecQ6e',
    defaultMessage: 'IBM Cloud Code Engine',
  },
  blockchainDescription: {
    id: 'w3AaOs',
    defaultMessage: 'Build applications on an immutable blockchain ledger',
  },
  databasesForMysqlName: {
    id: 'yPSXlW',
    defaultMessage: 'IBM Cloud Databases for MySQL',
  },
  schematicsDescription: {
    id: 'O7DLNZ',
    defaultMessage:
      'Managed service to provision resources with terraform templates',
  },
  tektonName: {
    id: '4PVFhB',
    defaultMessage: 'Tekton on IBM Cloud',
  },
  sqlQueryDescription: {
    id: 'IW8Ocm',
    defaultMessage:
      'Serverless, interactive querying service to analyze object storage data',
  },
  qiskitRuntimeDescription: {
    id: 'sk3srD',
    defaultMessage: 'Low-latency execution environment for quantum programs',
  },
  compianceCenterName: {
    id: 'S4quML',
    defaultMessage: 'Security and Compliance Center',
  },
  streamingAnalyticsDescription: {
    id: '4MGh22',
    defaultMessage: 'Dashboard for real-time analysis of data streams',
  },
  apiConnectName: {
    id: 'qNKPiq',
    defaultMessage: 'IBM API Connect®',
  },
  appSubheadB: {
    id: 'bA3qoG',
    defaultMessage:
      'Use your existing infrastructure—even edge or other public clouds—with IBM Cloud services, APIs, access policies, security controls and compliance with ',
  },
  appSubheadC: {
    id: 'S9ECjo',
    defaultMessage: 'IBM Cloud Satellite',
  },
  databasesDescription: {
    id: 'SAgOYa',
    defaultMessage: 'Store, query and analyze structured data',
  },
  openShiftDescription: {
    id: '8QvQ3A',
    defaultMessage:
      'Container platform to build, deploy, and scale critical applications',
  },
  db2WarehouseDescription: {
    id: 'rNUj2n',
    defaultMessage: 'Managed data warehouse on IBM Cloud or AWS',
  },
  watsonAssistantDescription: {
    id: 'ZNJrOS',
    defaultMessage: 'Virtual agents customizable to any domain',
  },
  instructLabDescription: {
    id: 'R9nBgc',
    defaultMessage: 'Deploy customed AI models as a service',
  },
  redHatDescription: {
    id: 'qbu9vV',
    defaultMessage: 'Scalable AI and ML development platform for Enterprises',
  },
  rhelDescription: {
    id: 'AkQzm9',
    defaultMessage:
      'Foundation model to consistently power AI enterprise applications',
  },
  directLinkName: {
    id: 'wKdz2h',
    defaultMessage: 'IBM Cloud Direct Link',
  },
  vpcDescription: {
    id: '71QhXK',
    defaultMessage: 'Virtual servers with enhanced network security',
  },
  appConfigurationDescription: {
    id: 'VrOy6P',
    defaultMessage: 'SDK, dashboard and API for application feature management',
  },
  qiskitDescription: {
    id: '6+Wt0y',
    defaultMessage: 'Python SDK for open-source quantum development',
  },
  keyProtectName: {
    id: 'WFE8I7',
    defaultMessage: 'IBM Key Protect for IBM Cloud',
  },
  appSubhead: {
    id: 'r4V0z8',
    defaultMessage:
      'A full stack cloud platform with over 230+ products and services covering data, containers, AI, IoT, and blockchain.',
  },
  aiDescription: {
    id: 'LD18MO',
    defaultMessage:
      'Use AI on IBM Cloud or build your own machine learning models',
  },
  infosphereName: {
    id: 'YYeR+/',
    defaultMessage: 'IBM InfoSphere® Information Server on Cloud',
  },
  watsonAssistantName: {
    id: 'H2B6zg',
    defaultMessage: 'IBM Watson Assistant',
  },
  instructLabName: {
    id: '1EvbuP',
    defaultMessage: 'InstructLab on IBM Cloud',
  },
  redHatName: {
    id: 'sQPkET',
    defaultMessage: 'Red Hat OpenShift AI on IBM Cloud',
  },
  rhelName: {
    id: 'Xg7ddL',
    defaultMessage: 'RHEL AI',
  },
  iotPlatformDescription: {
    id: 'EI6gkl',
    defaultMessage:
      'See, predict and prevent issues with advanced AI-powered remote monitoring and computer vision for assets and operations.',
  },
  codeengineName: {
    id: 'cecQ6e',
    defaultMessage: 'IBM Cloud Code Engine',
  },
  turbonomicDescription: {
    id: 'vQzYxD',
    defaultMessage:
      'Software to automate application resource management and optimize costs',
  },
  activityTrackerName: {
    id: '1ioGP+',
    defaultMessage: 'IBM Cloud Activity Tracker',
  },
  loggingAndMonitoringDescription: {
    id: 'dmI63x',
    defaultMessage:
      'Provide a comprehensive view into the health and behavior of your apps and infrastructure',
  },
  appIdName: {
    id: '1Oh28L',
    defaultMessage: 'IBM Cloud App ID',
  },
  sysdigName: {
    id: '/Fo9fO',
    defaultMessage: 'IBM Cloud Monitoring',
  },
  asperaDescription: {
    id: 'bRDwJk',
    defaultMessage: 'UI and CLI to rapidly move large files',
  },
  continuousDeliveryDescription: {
    id: 'KqvGDN',
    defaultMessage:
      'UI and CLI based DevOps workflows based on Tekton Pipelines',
  },
  pakIntegrationName: {
    id: 'Mc9NMX',
    defaultMessage: 'IBM Cloud Pak for Integration',
  },
  hyperProtectDbaasDescription: {
    id: 'R/fawH',
    defaultMessage: 'Managed PostgreSQL and MongoDB for sensitive data',
  },
  databasesName: {
    id: 'RYbE1p',
    defaultMessage: 'Databases',
  },
  schematicsName: {
    id: '5rIK92',
    defaultMessage: 'IBM Cloud Schematics',
  },
  watsonAiopsDescription: {
    id: 'WtlKy/',
    defaultMessage:
      'DevOps management tool with AI analysis and recommendations',
  },
  watsonStudioName: {
    id: '7r2HpS',
    defaultMessage: 'IBM Watson Studio',
  },
  watsonAiopsName: {
    id: 'Sp7oTG',
    defaultMessage: 'IBM Cloud Pak for AIOps',
  },
  informixDescription: {
    id: 'TvkU5U',
    defaultMessage: 'Managed DB for time series, spatial, NoSQL and SQL data',
  },
  databasesForMongodbName: {
    id: 'YLUpsk',
    defaultMessage: 'IBM Cloud Databases for MongoDB',
  },
  skytapDescription: {
    id: 'CU1tuU',
    defaultMessage:
      'Virtualization for x86, AIX, System i and Power applications',
  },
  networkDescription: {
    id: 'o5DTVG',
    defaultMessage: 'Run and manage public, private and virtual networks',
  },
  messagesForRabbitmqDescription: {
    id: 'p33z2x',
    defaultMessage: 'Managed message broker',
  },
  edgeComputingDescription: {
    id: 'j/GhH0',
    defaultMessage: 'An autonomous management platform for edge computing',
  },
  appSubheadBA: {
    id: 'pxCNur',
    defaultMessage:
      'Take the cloud anywhere -on premises, multicloud and to the Edge- with',
  },
  appSubheadBB: {
    id: '7cWwgR',
    defaultMessage:
      'to take Cloud anywhere: on premises, multicloud and to the Edge.',
  },
  appConnectDescription: {
    id: '4bbD8a',
    defaultMessage: 'Codeless connectors for your data, apps and APIs',
  },
  analyticsEngineDescription: {
    id: '/xOV9k',
    defaultMessage:
      'PaaS to build analytics applications on Apache Spark and Hadoop ',
  },
  apiConnectDescription: {
    id: 'QG19qO',
    defaultMessage: 'A toolkit to rapidly create, secure and manage APIs',
  },
  virtualServersDescription: {
    id: 'Logr9M',
    defaultMessage:
      'Accelerate and securely scale gen AI and traditional AI workloads.',
  },
  blockStorageDescription: {
    id: 'N3uAdR',
    defaultMessage:
      'The lowest latency, highest redundancy data storage option',
  },
  hyperProtectVirtualServersDescription: {
    id: 'nmblXM',
    defaultMessage: 'Virtual servers for workloads with sensitive data',
  },
  databasesForRedisName: {
    id: 'ABMG1N',
    defaultMessage: 'IBM Cloud Databases for Redis',
  },
  cloudantDescription: {
    id: '4t44vN',
    defaultMessage: 'Managed PCI-compliant JSON document store on CouchDB',
  },
  bareMetalDescription: {
    id: '6H+967',
    defaultMessage: 'Dedicated hardware for maximum performance',
  },
  messagesForRabbitmqName: {
    id: 'C8DVFE',
    defaultMessage: 'IBM Cloud Messages for RabbitMQ',
  },
  analyticsName: {
    id: 'GZJpDf',
    defaultMessage: 'Analytics',
  },
  databasesForEtcdDescription: {
    id: '3oH2rw',
    defaultMessage: 'Managed distributed key-value store',
  },
  iotDescription: {
    id: 'NqlVin',
    defaultMessage: 'Connect and manage edge devices',
  },
  objectStorageName: {
    id: 'L191bn',
    defaultMessage: 'IBM Cloud Object Storage',
  },
  watsonLanguageTranslatorDescription: {
    id: 'y3M3RD',
    defaultMessage: 'API for translation with domain-specific models',
  },
  sslCertificatesDescription: {
    id: '4kPVn5',
    defaultMessage: 'Certificates for cloud resources',
  },
  pakDataName: {
    id: 'LavEEz',
    defaultMessage: 'IBM Cloud Pak for Data',
  },
  vmwareSolutionsDescription: {
    id: '5DWH+i',
    defaultMessage: 'Hosting for virtualized workloads',
  },
  watsonKnowledgeStudioDescription: {
    id: 'yaKewA',
    defaultMessage:
      'Visual interface to teach Watson domain-specific knowledge',
  },
  integrationName: {
    id: 'bx7Ou/',
    defaultMessage: 'Integration',
  },
  websphereDescription: {
    id: 'DXendR',
    defaultMessage: 'Runtime and SDK for Java applications',
  },
  appHeadline: {
    id: '8joZWX',
    defaultMessage: 'Explore IBM Cloud products',
  },
  databasesForMongodbDescription: {
    id: 'mXhQDU',
    defaultMessage: 'Managed NoSQL JSON document store',
  },
  watsonDiscoveryName: {
    id: 'qyzNY4',
    defaultMessage: 'IBM Watson Discovery',
  },
  containerRegistryName: {
    id: 'l8nRNG',
    defaultMessage: 'IBM Cloud Container registry',
  },
  hyperProtectCryptoServicesName: {
    id: 'Hku3el',
    defaultMessage: 'IBM Cloud Hyper Protect Crypto Services',
  },
  secureGatewayName: {
    id: '/H9IZy',
    defaultMessage: 'Secure gateway',
  },
  watsonSpeechToTextDescription: {
    id: 'LIuKA0',
    defaultMessage: 'API for real-time speech recognition and transcription',
  },
  storageName: {
    id: 'DUIDEq',
    defaultMessage: 'Storage',
  },
  watsonTextToSpeechName: {
    id: 'g61N0j',
    defaultMessage: 'IBM Watson Text to Speech',
  },
  secureGatewayDescription: {
    id: 'Xj6Wse',
    defaultMessage: 'Secure tunnels between cloud and external environments',
  },
  vpsHostingName: {
    id: '1PewX/',
    defaultMessage: 'IBM Cloud VPS Hosting',
  },
  loadBalancerName: {
    id: 'kUEe+0',
    defaultMessage: 'IBM Cloud Load balancer',
  },
  quantumName: {
    id: 'i956Rq',
    defaultMessage: 'Quantum',
  },
  blockchainName: {
    id: 'OkWAlI',
    defaultMessage: 'Blockchain',
  },
  ibmCloudPaksName: {
    id: 'SgxPaA',
    defaultMessage: 'IBM Cloud Paks',
  },
  watsonLanguageClassifierName: {
    id: 'Udbq5C',
    defaultMessage: 'IBM Watson Natural Language Classifier',
  },
  cloudInternetServicesName: {
    id: 'vEECcp',
    defaultMessage: 'IBM Cloud Internet Services',
  },
  horizonName: {
    id: 'vPqMb0',
    defaultMessage: 'Dizzion Managed DaaS on IBM Cloud',
  },
  fileStorageDescription: {
    id: '0vyqQ5',
    defaultMessage:
      'The simplest solution for data organized into files and folders',
  },
  databasesForPostgresqlDescription: {
    id: '7E1J9z',
    defaultMessage: 'Managed SQL database',
  },
  loggingAndMonitoringName: {
    id: 'Pqh2Pq',
    defaultMessage: 'Observability',
  },
  securityModuleName: {
    id: 'nnY5GS',
    defaultMessage: 'IBM Cloud Hardware Security Module 7.0',
  },
  databasesForEnterprisedbName: {
    id: 'dmETcB',
    defaultMessage: 'IBM Cloud Databases for EnterpriseDB',
  },
  horizonDescription: {
    id: '/NWI1J',
    defaultMessage: 'Virtual desktops, in the cloud and managed',
  },
  blockchainPlatformName: {
    id: 'CAhGT6',
    defaultMessage: 'IBM Blockchain Platform',
  },
  sqlQueryName: {
    id: 'Cpt0qn',
    defaultMessage: 'IBM Cloud Data Engine',
  },
  backupName: {
    id: 'oSZCMT',
    defaultMessage: 'IBM Cloud Backup',
  },
  tektonDescription: {
    id: 'mzfhv8',
    defaultMessage: 'Kubernetes-native CI and CD pipelines',
  },
  automationDescription: {
    id: 'U/Zosp',
    defaultMessage:
      'Automate workflows from IT operations to business processes',
  },
  databasesForElasticsearchName: {
    id: 'bw4KmR',
    defaultMessage: 'IBM Cloud Databases for Elasticsearch',
  },
  pakSecurityDescription: {
    id: 'JCGVvu',
    defaultMessage: 'Security auditing, reporting, analysis and governance',
  },
  websphereName: {
    id: 'LRDydZ',
    defaultMessage: 'IBM WebSphere Application Server on Cloud',
  },
  dnsName: {
    id: 'YZGl5T',
    defaultMessage: 'Domain name services',
  },
  blockStorageName: {
    id: 'aOPlYn',
    defaultMessage: 'IBM Cloud Block Storage',
  },
  virtualServersName: {
    id: 'S5zYlw',
    defaultMessage: 'GPUs on IBM Cloud',
  },
  eventStreamsName: {
    id: 'ioUkiO',
    defaultMessage: 'IBM Event Streams',
  },
  ibmCloudPaksDescription: {
    id: '9L6a1L',
    defaultMessage:
      'Integrated and certified applications on Red Hat OpenShift',
  },
  dnsDescription: {
    id: 'adJBTQ',
    defaultMessage: 'Public and private DNS and domain registration',
  },
  db2WarehouseName: {
    id: 'wtaE2Q',
    defaultMessage: 'IBM Db2 Warehouse',
  },
  watsonDiscoveryDescription: {
    id: 'njUA7c',
    defaultMessage: 'Search and analytics engine that adapts to custom domains',
  },
  fileStorageName: {
    id: 'M6gSgN',
    defaultMessage: 'IBM Cloud File Storage',
  },
  developerToolsDescription: {
    id: 'a2I/+Q',
    defaultMessage: 'Manage infrastructure, environments and deployments',
  },
  pakIntegrationDescription: {
    id: 'muvaZX',
    defaultMessage:
      'An AI-powered integration software solution to connect your apps and data across any cloud.',
  },
  containerRegistryDescription: {
    id: 'fyaRux',
    defaultMessage: 'SaaS for container storage and management',
  },
  cdnDescription: {
    id: 'b9HZtl',
    defaultMessage: 'Content caching and delivery on the Akamai network',
  },
  databasesForElasticsearchDescription: {
    id: 'yC3Bny',
    defaultMessage: 'Managed JSON document store for full-text search',
  },
  databasesForEnterprisedbDescription: {
    id: '7E1J9z',
    defaultMessage: 'Managed SQL database',
  },
  sysdigDescription: {
    id: 'DmNdXe',
    defaultMessage: 'Managed dashboard for Kubernetes devops',
  },
  storageDescription: {
    id: 'xS4ray',
    defaultMessage: 'Store, migrate and back up your data',
  },
  codeengineDescription: {
    id: 'QXONVT',
    defaultMessage: 'Serverless container hosting platform as a service',
  },
  watsonCatalogName: {
    id: 'vQF5Zs',
    defaultMessage: 'IBM Watson Knowledge Catalog',
  },
  analyticsDescription: {
    id: 'qgPKkY',
    defaultMessage: 'Aggregate and analyze large datasets',
  },
  vmwareSolutionsName: {
    id: 'EkcUrj',
    defaultMessage: 'IBM Cloud for VMware Solutions',
  },
  watsonStudioDescription: {
    id: 'SIrkDV',
    defaultMessage: 'IDE to build, run and manage AI models',
  },
  watsonTextToSpeechDescription: {
    id: 'YwEQe3',
    defaultMessage: 'API for real-time text to speech conversion',
  },
  turbonomicName: {
    id: 'Os+JZk',
    defaultMessage: 'IBM Turbonomic® Application Resource Management',
  },
  cloudantName: {
    id: '7mrMpv',
    defaultMessage: 'IBM Cloudant®',
  },
  compianceCenterDescription: {
    id: '8tEeK+',
    defaultMessage:
      'SaaS to define and audit the compliance posture of your cloud',
  },
  networkName: {
    id: '8wm6f9',
    defaultMessage: 'Networking',
  },
  appConnectName: {
    id: 'XELYQp',
    defaultMessage: 'IBM App Connect',
  },
  securityDescription: {
    id: 'X28+9+',
    defaultMessage:
      'Secure your cloud resources and simplify regulatory compliance',
  },
  cloudpakbaName: {
    id: 'hRPlIx',
    defaultMessage: 'IBM Cloud Pak for Business Automation',
  },
  cloudpaknaName: {
    id: 'R1DO4B',
    defaultMessage: 'IBM Cloud Pak for Network Automation',
  },
  watsonKnowledgeStudioName: {
    id: 'rlq8Fg',
    defaultMessage: 'IBM Watson Knowledge Studio',
  },
  automationName: {
    id: 'Fn4YKy',
    defaultMessage: 'Automation',
  },
  securityAdvisorDescription: {
    id: 'U0mQyT',
    defaultMessage:
      'Dashboard for security management, analysis and remediation',
  },
  aiName: {
    id: '1TonIP',
    defaultMessage: 'AI / machine learning',
  },
  databasesForEtcdName: {
    id: 'TleofT',
    defaultMessage: 'IBM Cloud Databases for etcd',
  },
  skytapName: {
    id: 'hFnvg2',
    defaultMessage: 'IBM Cloud for Skytap Solutions',
  },
  logAnalysisDescription: {
    id: 'uzKLXd',
    defaultMessage: 'Analysis dashboard for system and application logs',
  },
  powerVirtualServerName: {
    id: '5ftS+u',
    defaultMessage: 'IBM Power Systems Virtual Servers',
  },
  databasesForMysqlDescription: {
    id: 'QVh/NP',
    defaultMessage:
      'A fully managed MySQL relational database service. Deploy and scale effortlessly to drive innovation.',
  },
  computeName: {
    id: 'ab7TEe',
    defaultMessage: 'Compute',
  },
  mdmName: {
    id: 'hUqsVf',
    defaultMessage: 'IBM Master Data Management on Cloud',
  },
  containersName: {
    id: 'TDDlIs',
    defaultMessage: 'Containers',
  },
  networkAppliancesName: {
    id: 'gaWoWa',
    defaultMessage: 'Gateway appliances',
  },
  cdnName: {
    id: 'pAspmM',
    defaultMessage: 'IBM Cloud Content Delivery Network',
  },
  mdmDescription: {
    id: 'CQilD5',
    defaultMessage: 'Managed master data storage',
  },
  loudNetworkSecurityDescription: {
    id: '8yy81e',
    defaultMessage:
      'Hardware and software firewalls, network security group management',
  },
  vpcName: {
    id: 'QIXig5',
    defaultMessage: 'IBM Cloud Virtual Server for VPC',
  },
  securityName: {
    id: 'Py189G',
    defaultMessage: 'Security',
  },
  databasesForPostgresqlName: {
    id: 'iEOCYm',
    defaultMessage: 'IBM Cloud Databases for PostgreSQL',
  },
  secretsManagerDescription: {
    id: 'y/JVM1',
    defaultMessage: 'Single-tenant, dedicated instance to manage your secrets',
  },
  backupDescription: {
    id: '+h71Kv',
    defaultMessage:
      'Fully encrypted backup and recovery across multiple datacenters',
  },
  databasesForRedisDescription: {
    id: 'xWOoBo',
    defaultMessage: 'Managed in-memory key value store',
  },
  codeEngineDescription: {
    id: 'QXONVT',
    defaultMessage: 'Serverless container hosting platform as a service',
  },
  quantumDescription: {
    id: 'VQUAYA',
    defaultMessage: 'Run code on real quantum systems using a full-stack SDK',
  },
  computeDescription: {
    id: 'YTFqSU',
    defaultMessage: 'Run workloads on cloud infrastructure',
  },
  developerToolsName: {
    id: 'g/w+Mb',
    defaultMessage: 'Developer tools',
  },
  watsonLanguageTranslatorName: {
    id: 'ScFEs1',
    defaultMessage: 'IBM Watson Language Translator',
  },
  cloudFunctionsName: {
    id: 'Gz0Q3f',
    defaultMessage: 'IBM Cloud Functions',
  },
  watsonCatalogDescription: {
    id: 'qIvTZ4',
    defaultMessage: 'SaaS for AI data management',
  },
  blockchainPlatformDescription: {
    id: 'fZYnzi',
    defaultMessage: 'Blockchain SDK based on Hyperledger Fabric',
  },
  watsonSpeechToTextName: {
    id: '04jLb9',
    defaultMessage: 'IBM Watson Speech to Text',
  },
  iotName: {
    id: 'v9mtsp',
    defaultMessage: 'Internet of things',
  },
  directLinkDescription: {
    id: 'Ayup/o',
    defaultMessage: 'Physical or virtual private connections to IBM Cloud',
  },
  cloudInternetServicesDescription: {
    id: 'U8MRda',
    defaultMessage: 'Load balancing and CDN solution',
  },
  containersDescription: {
    id: 'u9zWS+',
    defaultMessage: 'Deploy applications consistently across environments',
  },
  istioDescription: {
    id: 'pIUXrB',
    defaultMessage: 'A service mesh for microservices in Kubernetes clusters',
  },
  vpsHostingDescription: {
    id: 'Zojq+P',
    defaultMessage: 'Easily manage fast-moving workloads.',
  },
  appIdDescription: {
    id: 'G8baz3',
    defaultMessage:
      'Compliant authentication, authorization and user data SaaS',
  },
  keyProtectDescription: {
    id: 'Irwwbi',
    defaultMessage:
      'Encryption key provisioning and storage for IBM Cloud apps',
  },
  loadBalancerDescription: {
    id: 'Bu3YcZ',
    defaultMessage: 'Traffic flow management for cloud applications',
  },
  db2Description: {
    id: '7E1J9z',
    defaultMessage: 'Managed SQL database',
  },
  kubernetesDescription: {
    id: 'WBSGau',
    defaultMessage:
      'Container hosting with self-healing and horizontal scaling',
  },
  objectStorageDescription: {
    id: 'XzhFjl',
    defaultMessage: 'Unstructured cloud data storage with an API frontend',
  },
  streamingAnalyticsName: {
    id: 'pGC68e',
    defaultMessage: 'IBM Streaming Analytics',
  },
  openShiftName: {
    id: 'iy++Ui',
    defaultMessage: 'Red Hat® OpenShift® on IBM Cloud',
  },
  appConfigurationName: {
    id: '+9vdTn',
    defaultMessage: 'IBM Cloud App Configuration',
  },
  edgeComputingName: {
    id: 'S8NAfT',
    defaultMessage: 'IBM Edge Application Manager',
  },
  ibmcloudlogsName: {
    id: 'uTRasq',
    defaultMessage: 'IBM Cloud Logs',
  },
  ibmcloudlogsDescription: {
    id: 'siBewP',
    defaultMessage: 'Log and analyze activity in your infrastructure',
  },
});

export default messages;
